/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, InputLabel, OutlinedInput, styled, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { CurrencyJSON, FundingSource, getProjectSize, projectStatus, projectType, Units } from "../../../common/const";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import LinkIcon from '@mui/icons-material/Link';
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../common/common";
import { LoadingPage } from "../../../common/LoadingPage";
import { useSelector } from "react-redux";

const DemoTabs = styled(Tabs)(({ theme }) => ({
    minWidth: 200,
    [theme.breakpoints.down('xs')]: {
        marginLeft: '0%',
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '20px',
        fontSize: 10,
    },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
    minWidth: 110,
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'capitalize',
    [theme.breakpoints.down('xs')]: {
        minWidth: 8,
        fontSize: 10,
    },
    '&:hover': {
        backgroundColor: '#f6f7ff',
        color: 'black',
    },
}));

const DemoGrid = styled(Grid)(({ theme }) => ({
    border: '1px solid lightgray',
    padding: 10
}));

const DemoTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 12,
    textAlign: 'justify'
}));

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 12
}));

const HeadingTypo = styled(Typography)(({ theme }) => ({
    fontSize: 16,
    borderBottom: '2px solid #3f51b5',
    marginBottom: 10,
}));

const Cell = styled(TableCell)({
    padding: '0px 0px 0px 20px'
});

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const ProjectDetails = ({
    selectedProject,
    rows,
    setRows,
    getData
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [activeTab, setActiveTab] = useState(0);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [url, setUrl] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const [resources, setResource] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);

    const getAcceptType = (fileType) => {
        if (fileType === 'Image') {
            return '.jpeg,.jpg,.png,.PNG';
        }
        if (fileType !== '2D' && fileType !== '3D') {
            return '.pdf';
        }
        return '*/*';
    };

    const handleFileUpload = (event, fileType) => {
        const file = event.target.files[0];
        if (file) {
            setResource((prevData) => ({
                ...prevData,
                [fileType.toLowerCase().replace(/\s+/g, '')]: file,
            }));
            setRows((prevData) =>
                prevData.map((row) => {
                    if (row.type === fileType) {
                        return {
                            ...row,
                            resource: file.name,
                            size: `${(file.size / 1024).toFixed(2)} KB`,
                            extension: file.name.split('.').pop(),
                        };
                    }
                    return row;
                })
            );
        }
    };

    const handleRemove = (fileType) => {
        setResource((prevData) => ({
            ...prevData,
            [fileType.toLowerCase().replace(/\s+/g, '')]: null,
        }));

        setRows((prevData) =>
            prevData.map((row) => {
                if (row.type === fileType) {
                    return {
                        ...row,
                        resource: '--',
                        size: '--',
                        extension: '--',
                    };
                }
                return row;
            })
        );
    }

    const handleSubmit = async () => {
        setDataLoading(true);
        const formData = new FormData();
        formData.append('project_images', resources?.image);
        formData.append('name', selectedProject.name);
        formData.append('organization_id', selectedProject.organization_id);
        formData.append('owner_id', selectedProject.owner_id);
        if (resources?.url) {
            formData.append('website_url', JSON.stringify(resources?.url?.split(',')));
        } else if (resources?.url === '') {
            formData.append('website_url', JSON.stringify([]));
        }
        try {
            if (selectedProject?.project_id) {
                const response = await apiRequest('put', `/project/${selectedProject?.project_id}`, formData);
                if (response?.data) {
                    showNotification(response?.data?.message, 'success');
                    getData();
                    setResource(null);
                    setDataLoading(false);
                }
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    return (
        <>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Dialog open={dialogOpen} fullWidth maxWidth="sm">
                <DialogTitle>Save Url</DialogTitle>
                <DialogContent>
                    <Box style={{ marginTop: 10 }}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Project URL</InputLabel>
                            <OutlinedInput
                                label="Website URL"
                                id="standard-adornment-password"
                                type='text'
                                onChange={(e) => {
                                    const newUrl = e.target.value;
                                    const urls = newUrl.split(',').map((url) => url.trim());
                                    const isValidUrls = urls.every((url) => {
                                        try {
                                            new URL(url);
                                            return true;
                                        } catch (e) {
                                            return false;
                                        }
                                    });
                                    setIsValid(isValidUrls);
                                    setUrl(e.target.value);
                                }}
                            />
                            <FormHelperText>
                                {isValid
                                    ? 'Enter multiple URLs separated by commas.'
                                    : 'Invalid URL format. Please check the URLs.'}
                            </FormHelperText>
                        </FormControl>
                        {rows.find((f) => f.type === 'URL').resource !== '--' && rows.find((f) => f.type === 'URL').resource?.split(',')?.map((a) => (
                            <Box style={{ display: 'flex', justifyContent: 'space-between', margin: 10, alignItems: 'center' }}>
                                <Typography variant="body1">{a}</Typography>
                                <Tooltip title="remove website url">
                                    <IconButton onClick={() => {
                                        const existingURL = rows.find((f) => f.type === 'URL').resource;
                                        let updatedURL = existingURL.replace(new RegExp(`,${a}$`), "").trim();
                                        if (existingURL.startsWith("https://")) {
                                            updatedURL = existingURL.replace(/^https:\/\/[^,]+,?/, '').trim();
                                        }
                                        if (updatedURL.startsWith(',')) {
                                            updatedURL = updatedURL.substring(1).trim();
                                        }
                                        if (updatedURL[0] === ',') {
                                            updatedURL = updatedURL.slice(1).trim();
                                        }
                                        setResource((prevData) => ({
                                            ...prevData,
                                            url: updatedURL,
                                        }));
                                        setRows((prevData) =>
                                            prevData.map((row) => {
                                                if (row.type === 'URL') {
                                                    const resourceValue = updatedURL === '' ? '--' : updatedURL;
                                                    return {
                                                        ...row,
                                                        resource: resourceValue,
                                                        extension: resourceValue !== '--' ? 'URL' : '--',
                                                    };
                                                }
                                                return row;
                                            })
                                        );
                                    }}>
                                        <RemoveCircleOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={() => {
                        if (url) {
                            if (isValid) {
                                const existingURL = rows.find((f) => f.type === 'URL').resource;
                                setResource((prevData) => ({
                                    ...prevData,
                                    url: existingURL !== '--' ? `${existingURL},${url}` : url,
                                }));
                                setRows((prevData) =>
                                    prevData.map((row) => {
                                        if (row.type === 'URL') {
                                            return {
                                                ...row,
                                                resource: existingURL !== '--' ? `${existingURL},${url}` : url,
                                                extension: 'URL',
                                            };
                                        }
                                        return row;
                                    })
                                );
                                setUrl(null);
                            }
                            else {
                                showNotification('Invalid URL format. Please check the URLs', 'error');
                            }
                        }
                        setDialogOpen(false)
                    }}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <DemoTabs
                    value={activeTab}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={(event, newValue) => setActiveTab(newValue)}
                >
                    <DemoTab label="Details" value={0} />
                    {isUser?.code !== 'orgGuestUser' && (
                        <DemoTab label="Resources" value={1} />
                    )}
                </DemoTabs>
            </Box>
            {activeTab === 0 && (
                <Grid container mt={1}>
                    <DemoGrid item xs={12} sm={6} md={3}>
                        <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Attributes</HeadingTypo>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project ID:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject?.project_no || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Client Organization:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject?.client_organization || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project Owner:</DemoTypography>
                                    <DemoTypo variant="body2">{`${selectedProject?.owner?.first_name} ${selectedProject?.owner?.last_name !== null ? selectedProject?.owner?.last_name : ''}` || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Created By:</DemoTypography>
                                    <DemoTypo variant="body2">{`${selectedProject?.createduser?.first_name} ${selectedProject?.createduser?.last_name !== null ? selectedProject?.createduser?.last_name : ''}` || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project Creation Date:</DemoTypography>
                                    <DemoTypo variant="body2">{moment(selectedProject?.created_at).format('DD-MMM-YYYY') || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Target Occupancy Date:</DemoTypography>
                                    <DemoTypo variant="body2">{moment(selectedProject?.target_occupation).format('DD-MMM-YYYY') || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project Status:</DemoTypography>
                                    <DemoTypo variant="body2">{projectStatus.find((a) => a.value === selectedProject?.status)?.name || '--'}</DemoTypo>
                                </Box>
                            </Grid>
                        </Grid>
                    </DemoGrid>
                    <DemoGrid item xs={12} sm={6} md={3}>
                        <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Attributes</HeadingTypo>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project Type:</DemoTypography>
                                    <DemoTypo variant="body2">{projectType.find((a) => a.value === selectedProject.type)?.name || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Default Project Unit:</DemoTypography>
                                    <DemoTypo variant="body2">{Units.find((a) => a.value === selectedProject.default_project_units)?.name || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" gap={1}>
                                    <DemoTypography variant="body2">Project Area:</DemoTypography>
                                    <DemoTypo variant="body2">{getProjectSize(selectedProject?.default_project_units, selectedProject.project_area) || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Current Phase:</DemoTypography>
                                    <DemoTypo variant="body2">
                                        {selectedProject.is_certificate_need ?
                                            'Certificate of need/initial budget'
                                            :
                                            selectedProject.is_construction_document_enable ?
                                                'Construction Document (CD)'
                                                :
                                                selectedProject.is_contract_admin ?
                                                    'Contract Administration'
                                                    :
                                                    selectedProject.is_design_development_enable ?
                                                        'Design Development (DD)'
                                                        :
                                                        selectedProject.is_schematic_design_enable ?
                                                            'Schematic Design (SD)'
                                                            :
                                                            selectedProject.is_programing_enable ?
                                                                'Programming'
                                                                :
                                                                '--'}
                                    </DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Change Notes:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject.notes ? 'Enabled' : 'Disabled' || '--'}</DemoTypo>
                                </Box>
                            </Grid>
                        </Grid>
                    </DemoGrid>
                    <DemoGrid item xs={12} sm={6} md={3}>
                        <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Costing Details</HeadingTypo>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Funding Source:</DemoTypography>
                                    <DemoTypo variant="body2">{FundingSource.find((a) => a.value === selectedProject.funding_source)?.name || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Currency:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject?.currency || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Total Approved Budget:</DemoTypography>
                                    <DemoTypo variant="body2">{`${CurrencyJSON.find((a) => a.value === selectedProject.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(selectedProject?.total_approved_budget)}` || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Construction Cost:</DemoTypography>
                                    <DemoTypo variant="body2">{`${CurrencyJSON.find((a) => a.value === selectedProject.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(selectedProject?.total_construction_cost)}` || '--'}</DemoTypo>
                                </Box>
                            </Grid>
                        </Grid>
                    </DemoGrid>
                    <DemoGrid item xs={12} sm={6} md={3}>
                        <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Tax Details</HeadingTypo>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project Tax Exempt Status:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject?.is_tax_exempt ? 'Yes' : 'No'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Tax ID Number:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject?.tax_number || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DemoTypography variant="body2">Project Tax Rate:</DemoTypography>
                                    <DemoTypo variant="body2">{`${Number(selectedProject?.tax_rate).toFixed(2)} %` || '--'}</DemoTypo>
                                </Box>
                                <Box display="flex" gap={1}>
                                    <DemoTypography variant="body2">Taxable Option:</DemoTypography>
                                    <DemoTypo variant="body2">{selectedProject?.taxable_option ? JSON.parse(selectedProject?.taxable_option)?.toString() : '--'}</DemoTypo>
                                </Box>
                            </Grid>
                        </Grid>
                    </DemoGrid>
                    <DemoGrid item xs={12} sm={12} md={12} mt={1}>
                        <Box display="flex" gap={1}>
                            <DemoTypography variant="body2">Notes:</DemoTypography>
                            <DemoTypo variant="body2">{selectedProject?.notes || '--'}</DemoTypo>
                        </Box>
                    </DemoGrid>
                </Grid>
            )}
            {activeTab === 1 && (
                <Box mt={1}>
                    {(resources?.image || resources?.url) && (
                        <Button
                            color="primary"
                            size="small"
                            variant="contained"
                            style={{
                                float: 'right',
                                marginBottom: 10
                            }}
                            onClick={() => handleSubmit()}
                        >
                            Update
                        </Button>
                    )}
                    <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                        <TableContainer>
                            <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                <TableHead>
                                    <TableRow>
                                        <Cell>Extension</Cell>
                                        <Cell>Type</Cell>
                                        <Cell>Resource</Cell>
                                        <Cell>Size</Cell>
                                        <Cell>Action</Cell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <TableRow key={index} sx={{ padding: 10 }}>
                                            <Cell>
                                                <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                                    {(row.extension !== '--' && row?.type === 'Image') ? (
                                                        <img src="/images/gallary.png" alt="blog img" style={{ width: 20 }} />
                                                    ) : (row.extension !== '--' && row?.type === 'URL') ? (
                                                        <img src="/images/URL.png" alt="blog img" style={{ width: 20 }} />
                                                    ) : row.extension !== '--' && (
                                                        <img src="/images/pdf.svg" alt="blog img" style={{ width: 15 }} />
                                                    )}
                                                    {row.extension}
                                                </Box>
                                            </Cell>
                                            <Cell>{row.type}</Cell>
                                            <Cell>
                                                {row.type === 'URL' ? (
                                                    row?.resource !== '--' && row?.resource?.split(',').map((a) => (
                                                        <>
                                                            <Tooltip title={a}>
                                                                <a href={a} target="_blank" rel="noreferrer">{a.slice(0, 50)}</a>
                                                            </Tooltip>
                                                            <br />
                                                        </>
                                                    ))
                                                ) :
                                                    row.resource}
                                            </Cell>
                                            <Cell>{row.size}</Cell>
                                            <Cell>
                                                {row.extension !== '--' && row.type !== 'URL' ? (
                                                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                        <IconButton onClick={() => handleRemove(row.type)} style={{ padding: 0 }}>
                                                            <RemoveCircleOutlineIcon />
                                                        </IconButton>
                                                        <Box style={{ paddingTop: '7px' }}>
                                                            <a
                                                                href='#'
                                                                onClick={async () => {
                                                                    const url = `${process.env.REACT_APP_IMAGEURL}bbn=${row?.sortUrl}&uid=${user?.user_id}`;
                                                                    const response = await fetch(url, { method: 'GET' });
                                                                    const blob = await response.blob();
                                                                    const link = document.createElement('a');
                                                                    link.href = window.URL.createObjectURL(blob);
                                                                    link.download = `${row?.resource}`; // <-- set file name here
                                                                    link.click();
                                                                }}
                                                            >
                                                                <FileDownloadIcon />
                                                            </a>
                                                        </Box>
                                                    </Box>
                                                ) : row.type === 'URL' ? (
                                                    <IconButton onClick={() => setDialogOpen(true)} style={{ padding: 0 }}>
                                                        <LinkIcon />
                                                    </IconButton>
                                                ) : (
                                                    <IconButton component="label" style={{ padding: 0 }}>
                                                        <CloudUploadIcon />
                                                        <VisuallyHiddenInput
                                                            type="file"
                                                            onChange={(event) => handleFileUpload(event, row.type)}
                                                            accept={getAcceptType(row.type)}
                                                        />
                                                    </IconButton>
                                                )}
                                            </Cell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            )}
        </>
    )
}

export default ProjectDetails;